"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
var _keys2 = _interopRequireDefault(require("lodash/keys"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _Operator = _interopRequireDefault(require("../Operator"));
var _Value = _interopRequireDefault(require("../Value"));
var _operators = _interopRequireDefault(require("../operators.js"));
var _common = _interopRequireDefault(require("../../../../styles/common.css"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var operatorsTypes = (0, _keys2["default"])(_operators["default"]);
var getReduxFormField = function getReduxFormField(field, form) {
  return {
    value: field.value,
    error: form.errors[field.name],
    touched: true,
    onChange: function onChange(value) {
      return form.setFieldValue(field.name, value);
    }
  };
};
var Condition = function Condition(props) {
  var path = props.path,
    condition = props.condition,
    DataConnectorsPicker = props.DataConnectorsPicker,
    getDataConnectorMeta = props.getDataConnectorMeta;
  var getOperatorDefinition = function getOperatorDefinition() {
    if (!condition.dataConnector || !condition.operator) {
      return null;
    }
    return (0, _find2["default"])(_operators["default"][condition.dataConnector.type], {
      code: condition.operator
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'alert alert-info ' + _style["default"].conditionWrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: !condition.dataConnector ? _common["default"].lastRow : ''
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "".concat(path, ".dataConnector"),
    render: function render(_ref) {
      var field = _ref.field,
        form = _ref.form;
      return /*#__PURE__*/_react["default"].createElement(DataConnectorsPicker, {
        field: getReduxFormField(field, form),
        label: "",
        type: operatorsTypes,
        afterChange: function afterChange() {
          form.setFieldValue("".concat(path, ".operator"), '0');
          form.setFieldValue("".concat(path, ".value"), '');
        }
      });
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].condition
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "".concat(path, ".operator"),
    render: function render(_ref2) {
      var field = _ref2.field,
        form = _ref2.form;
      return /*#__PURE__*/_react["default"].createElement(_Operator["default"], {
        dataConnector: condition.dataConnector,
        field: getReduxFormField(field, form)
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "".concat(path, ".value"),
    render: function render(_ref3) {
      var field = _ref3.field,
        form = _ref3.form;
      return /*#__PURE__*/_react["default"].createElement(_Value["default"], {
        operator: getOperatorDefinition(),
        field: getReduxFormField(field, form),
        dataConnector: condition.dataConnector,
        getDataConnectorMeta: getDataConnectorMeta
      });
    }
  })));
};
Condition.propTypes = {
  path: _propTypes["default"].string,
  condition: _propTypes["default"].object,
  DataConnectorsPicker: _propTypes["default"].func,
  getDataConnectorMeta: _propTypes["default"].func
};
var _default = exports["default"] = Condition;